import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminAuthenticatedLayout } from '@/components/admin/AdminAuthenticatedLayout';

/**
 * Layout del back-office de SuperAdmin (`/admin/*`). Ver `docs/roles-and-personas.md` §2.
 *
 * Doble compuerta:
 *   1. `beforeLoad` — solo SuperAdmin (allowlist, resuelto por el backend en `user.isSuperAdmin`).
 *      Si no, redirige a `/dashboard` (un usuario normal no debe siquiera ver el área).
 *   2. `AdminTwoFactorGate` — exige el segundo factor (TOTP) y el token elevado antes de renderizar
 *      cualquier subruta. Sin token válido muestra el flujo enroll/verify en lugar del contenido.
 */
export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: ({ context }) => {
    if (!context.auth.user?.isSuperAdmin) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: AdminAuthenticatedLayout,
});
